import { render } from "./face-templates-modal.vue?vue&type=template&id=7d09fdb1&scoped=true"
import script from "./face-templates-modal.vue?vue&type=script&lang=js"
export * from "./face-templates-modal.vue?vue&type=script&lang=js"

import "./face-templates-modal.vue?vue&type=style&index=0&id=7d09fdb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d09fdb1"]])

export default __exports__